// import VConsole from 'vconsole';

import { networkWhitelist } from './util';

export const initVConsole = async () => {
    // const currentEnv = process.env.NEXT_PUBLIC_VSCONSOLE === 'true';

    // if (typeof window !== 'undefined' && currentEnv) {
    if (networkWhitelist()) {
        const VConsole = (await import('vconsole')).default;
        new VConsole();
        // console.log(`[vConsole] 已启用，当前环境：${currentEnv}`);
    }
};
